<template>
    <div class="candles">

        <canvas :ref="`chart_${ id }`"></canvas>

    </div>
</template>

<script>
    export default {
        name: "Candles",
        props: {
            data: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data() {
            return {
                id: '1',
                chart: null,
                maxBarCount: 18,

                currentHoverPriceData: 0
            }
        },
        computed: {
            getData() {
                if (this.data.length <= this.maxBarCount) {
                    return this.data
                } else {
                    return this.data.slice(0, this.maxBarCount)
                }
            },
            avgData() {
                return this.getData.reduce((sum, current) => current.o + sum, 0) / this.getData.length
            },
            lastData() {
                return this.getData[this.maxBarCount - 1].o
            }
        },
        methods: {
            drawChart() {
                var ctx = this.$refs[`chart_${ this.id }`].getContext('2d')

                this.chart = new window.Chart(ctx, {
                    type: 'candlestick',
                    data: {
                        datasets: [{
                            label: [],
                            data: this.getData,
                            color: {
                                up: "#00D383",
                                down: "#DD0041",
                                unchanged: "#999"
                            },
                            borderColor: {
                                up: "#00D383",
                                down: "#DD0041",
                                unchanged: "#999"
                            },
                            hoverBorderColor: this.getData.map((data) => {
                                return data.c < data.o ? '#DD0041' : '#00D383'
                            }),
                            hoverBorderWidth: 0
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: {
                            display: false
                        },
                        scales: {
                            yAxes: [
                                {
                                    display: false
                                }
                            ],
                            xAxes: [
                                {
                                    display: false
                                }
                            ]
                        },
                        tooltips: {
                            display: false,
                            enabled: false
                        },
                        hover: {
                            mode: "x",
                            intersect: false
                        }
                    }
                })
            }
        },
        mounted() {
            this.drawChart()
        },
        created() {
            this.id = (Math.floor(Math.random() * 1000000)).toString()
        },
        watch: {
            data() {
                if (this.getData.length !== 0) {

                    this.chart.data.datasets[0].data = this.getData

                    this.chart.update()

                }
            }
        }
    }
</script>